
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/track-your-shipping",
      function () {
        return require("private-next-pages/track-your-shipping/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/track-your-shipping"])
      });
    }
  